import React, { useState } from 'react';
import styled from 'styled-components';
import { func } from 'prop-types';
const CloseIconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 50px;
  padding-top: 29px;
  padding-right: 26px;
  cursor: pointer; /* Change cursor to pointer on hover */
  transition: fill 0.3s ease; /* Smooth transition for fill color */
  &:hover {
    fill: #9e9e9e; /* Lighter fill color on hover */
  }
`;

const CloseIconSvg = styled.svg`
  width: 14px;
  height: 14px;
`;

const CloseIcon = ({ onClick }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <CloseIconContainer
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <CloseIconSvg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill={hovered ? '#9e9e9e' : '#75767A'}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" />
      </CloseIconSvg>
    </CloseIconContainer>
  );
};
CloseIcon.propTypes = {
  onClick: func,
};

CloseIcon.defaultProps = {
  onClick: () => {},
};

export default CloseIcon;
